import React, { useState, useEffect } from "react";
import PrimaryLogo from "assets/images/oncotect-logos_primary.svg";
import HalfArrow from "assets/images/half-arrow.svg";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import {
  errorCleanUp,
  login,
  messageCleanUp,
} from "redux-store/auth/auth.slice";
import {
  error,
  loginSuccessMessage,
  activityInProcess,
  validToken,
} from "redux-store/auth/auth.selector";

import { getLoggedInUser } from "redux-store/user/user.slice";
import { userActivityInProcess, user } from "redux-store/user/user.selectors";
import { useNavigate } from "react-router-dom";

const SignInForm = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const loggedInUser = useSelector(user);
  const loading = useSelector(activityInProcess);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errMessages, setMessages] = useState({
    emailMessage: "",
    passwordMessage: "",
  });
  const signInError = useSelector(error);
  const succesMessage = useSelector(loginSuccessMessage);

  useEffect(() => {
    dispatch(errorCleanUp());
    dispatch(messageCleanUp());
  }, []);

  useEffect(() => {
    if (loggedInUser?.isAdmin) {
      navigate(`/admin/dashboard`);
    } else {
      navigate(`/user/home`);
    }
  }, [loggedInUser]);

  useEffect(() => {
    if (succesMessage === "Login successfully") {
      dispatch(getLoggedInUser());
    } else {
      navigate(`/`);
    }
  }, [succesMessage]);

  const onchange = (e: { target: { name: any; value: any } }) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email: string) => {
    // Regular expression pattern for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePassword = (password: string) => {
    // Regular expression pattern for password validation
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
    return passwordRegex.test(password);
  };

  const onSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    const { email, password } = formData;
    let validEmail = true;
    let validPass = true;

    if (!validateEmail(email)) {
      validEmail = false;
    }

    if (!validatePassword(password)) {
      validPass = false;
    }

    setMessages({
      ...errMessages,
      emailMessage: validEmail ? "" : "Invalid Email",
      passwordMessage: validPass
        ? ""
        : "Password must have at least 8 digits length, 1 character, 1 number",
    });
    if (validEmail && validPass) {
      dispatch(errorCleanUp());
      if (succesMessage !== "") {
        dispatch(messageCleanUp());
      }

      const res = await dispatch(login(formData));
      const message = res?.payload?.data?.message;
      if (message === "Email is not verified") {
        let path = "signup";
        navigate(`/auth/enter-otp/${formData.email}/${path}`);
      }
    }
  };

  return (
    <div className="tw-w-[80%] lg:tw-w-[70%] tw-mx-auto tw-py-10 tw-bg-[#ffffff] tw-flex tw-items-center tw-justify-center tw-rounded-[1.9375rem] shadow-small lg:shadow-large lg:tw-rounded-[1.25rem]">
      <div className="tw-w-[80%] tw-flex tw-flex-col tw-gap-3">
        {/* logo col */}
        <div className=" tw-flex tw-flex-col ">
          <div className="tw-w-[30%] lg:tw-w-[50%] tw-flex">
            <img src={PrimaryLogo} alt="logo" />
          </div>
        </div>
        {/* heading col */}
        <div className="tw-flex tw-flex-col">
          <div className="tw-opacity-50 tw-text-[0.75rem] tw-font-light lg:tw-text-[1rem] lg:tw-font-normal">
            Activation Account Sign In
          </div>
        </div>
        {/* form col */}
        <div>
          <form>
            <div className="tw-flex tw-flex-col tw-gap-4">
              <div className="tw-flex tw-flex-col tw-gap-1">
                <label
                  htmlFor="email"
                  className="tw-font-light tw-text-[14px] lg:tw-text-[1rem]"
                >
                  Email
                </label>
                <input
                  type="email"
                  className="tw-bg-palePink tw-p-2 focus:tw-outline-none tw-text-[14px] lg:tw-text-[0.875rem]"
                  name="email"
                  value={formData.email}
                  onChange={(e) => onchange(e)}
                  required
                />
                <span className=" tw-text-xs tw-text-red-500">
                  {errMessages.emailMessage}
                </span>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1">
                <div className="tw-flex tw-items-center tw-justify-between tw-font-light">
                  <label
                    htmlFor="password"
                    className="tw-font-light tw-text-[14px] lg:tw-text-[1rem]"
                  >
                    Password
                  </label>
                  <Link to="/auth/forgot-password">
                    <span className="tw-text-[12px] lg:tw-text-[0.875rem] tw-font-light tw-opacity-60 tw-cursor-pointer">
                      Forgot password?
                    </span>
                  </Link>
                </div>
                <input
                  type="password"
                  className="tw-bg-palePink tw-p-2 focus:tw-outline-none tw-text-[14px] lg:tw-text-[0.875rem]"
                  name="password"
                  value={formData.password}
                  onChange={(e) => onchange(e)}
                />
                <span className=" tw-text-xs tw-text-red-500">
                  {errMessages.passwordMessage}
                </span>
              </div>
              <div className="tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-2">
                <span className="tw-text-xs tw-text-red-500">
                  {signInError.message !== "" ? signInError.message : ""}
                </span>
                <button
                disabled={loading}
                  className="tw-w-[100%] tw-flex tw-items-center tw-gap-3 tw-rounded-full tw-bg-[#FF7B6D] tw-py-1.5 tw-px-3 tw-text-[0.875rem] lg:tw-text-base tw-font-semibold tw-text-[#FFFFFF] tw-uppercase"
                  type="submit"
                  onClick={(e) => {
                    onSubmit(e);
                  }}
                >
                  <span className=" tw-text-center tw-m-auto tw-flex tw-gap-2">
                    {loading ? "Signing in ..." : "Sign In"}
                    <img src={HalfArrow} alt="arrow" />
                  </span>
                </button>
                <button
                  className=" tw-w-[100%] tw-flex tw-items-center tw-gap-3 tw-rounded-full tw-bg-slate-200 tw-text-[#FF7B6D] tw-py-1.5 tw-px-3 tw-text-[0.875rem] lg:tw-text-base tw-font-semibold tw-uppercase"
                  onClick={(e) => {
                    navigate("/auth/sign-up");
                  }}
                >
                  <span className=" tw-text-center tw-m-auto tw-flex tw-gap-2">
                    Create Account
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
        {/* option col */}
      </div>
    </div>
  );
};

export default SignInForm;
